import React, { useState } from 'react';
import { AuthService } from 'services/authService';

interface AuthContainerProps {
	children: JSX.Element | JSX.Element[]
}

export const AuthContainer = ({ children }: AuthContainerProps) => {
	const [token, setToken] = useState(AuthService.token);

	React.useEffect(() => {
		AuthService.subscribe((token) => {
			setToken(token);
		});
		if (AuthService.token) {
			setToken(AuthService.token);
		} else {
			AuthService.requestAccessToken();
		}
	}, []);

	return token ? <>{children}</> : null;
};
